import { MinimalTarget } from '@/generated/model';

export type Position = {
  longitude: number; // ????? 12.602702140808105
  latitude: number;
  timeMicros: number;
};

type Measure = {
  id: number;
  name: string;
  value: string;
  timestampMicros: number;
};

export type DetailedPosition = Position & {
  geocodedAddress: string;
  poi?: string; // ??
  speed: number;
  countryName?: string;
  countryCode?: string;
  direction: number;
  color: string;
  icon: string;
  bubbleContent: string[];
  measures: Measure[]; // FIXME
};

export const inactiveTargetStates = ['New', 'Terminated', 'Removed', 'Slave'];

export type TrackableTargetsResponse = {
  targets: MinimalTarget[];
  containsAllTargets: boolean;
  trackingLimit: number;
};

export type TargetStatus = 'unknown' | 'nostatus' | 'validstatus';

export type Target = {
  target: MinimalTarget;
  currentPosition: DetailedPosition | null;
  trackedPath: Position[];
  serverTimeMicros: number; // BigInt
  hasTachographMetadataId: boolean;
};

export type TargetRequest = {
  targetId: number;
  fromTimeMicros: number; // BigInt
  asynchronous: boolean;
};
